import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// Preguntas avanzadas de anatomía del cuello - Nivel Profesional
export const neckQuestionsAdvanced = [
  
  // ============= NIVEL BÁSICO =============
  {
    id: 4001,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántos cartílagos tiene la laringe?",
    options: ["6", "9", "12", "15"],
    correctAnswer: 1,
    explanation: "La laringe tiene 9 cartílagos: 3 impares (tiroides, cricoides y epiglotis) y 3 pares (aritenoides, corniculados y cuneiformes). El cartílago tiroides es el más grande y forma la prominencia laríngea (manzana de Adán)."
  },
  {
    id: 4002,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Qué estructura marca el límite superior del cuello?",
    options: [
      "Hueso hioides",
      "Base del cráneo y borde inferior de la mandíbula",
      "Cartílago tiroides",
      "Vértebra C1"
    ],
    correctAnswer: 1,
    explanation: "El límite superior del cuello está formado por la base del cráneo posteriormente y el borde inferior de la mandíbula anteriormente. El límite inferior es la abertura torácica superior (manubrio esternal, primera costilla y vértebra T1)."
  },

  // ============= NIVEL GENERAL =============
  {
    id: 4003,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿A qué nivel vertebral típicamente se bifurca la arteria carótida común?",
    options: ["C3", "C4", "C5", "C6"],
    correctAnswer: 1,
    explanation: "La bifurcación de la arteria carótida común ocurre típicamente a nivel del borde superior del cartílago tiroides (C4). En este punto se divide en carótida externa (anterolateral) e interna (posteromedial). El seno carotídeo (barorreceptor) y el cuerpo carotídeo (quimiorreceptor) se localizan en la bifurcación."
  },
  {
    id: 4004,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al músculo cricotiroideo?",
    options: [
      "Nervio laríngeo recurrente",
      "Nervio laríngeo superior (rama externa)",
      "Nervio laríngeo superior (rama interna)",
      "Nervio vago"
    ],
    correctAnswer: 1,
    explanation: "El músculo cricotiroideo es el único músculo intrínseco de la laringe inervado por la rama externa del nervio laríngeo superior (del vago). Su lesión causa voz monótona y fatiga vocal. Todos los demás músculos intrínsecos son inervados por el nervio laríngeo recurrente."
  },
  {
    id: 4005,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura pasa superficial al músculo omohioideo?",
    options: [
      "Vena yugular interna",
      "Vena yugular externa",
      "Arteria carótida común",
      "Nervio vago"
    ],
    correctAnswer: 1,
    explanation: "La vena yugular externa discurre superficialmente, cruzando el músculo esternocleidomastoideo de forma oblicua y pasando superficial al omohioideo antes de drenar en la vena subclavia. Es visible en la superficie del cuello cuando hay aumento de presión venosa."
  },
  {
    id: 4006,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la función del músculo esternocleidomastoideo en la contracción unilateral?",
    options: [
      "Flexión del cuello hacia el mismo lado",
      "Rotación de la cabeza hacia el mismo lado",
      "Rotación de la cabeza hacia el lado opuesto e inclinación hacia el mismo lado",
      "Extensión del cuello"
    ],
    correctAnswer: 2,
    explanation: "La contracción unilateral del esternocleidomastoideo produce rotación de la cabeza hacia el lado opuesto e inclinación lateral hacia el mismo lado. La contracción bilateral produce flexión del cuello. Es inervado por el nervio accesorio (XI par) y ramas de C2-C3."
  },

  // ============= NIVEL COMPLEJO =============
  {
    id: 4007,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Post-tiroidectomía, paciente presenta voz bitonal y fatiga vocal, pero sin disnea. ¿Qué nervio se lesionó?",
    options: [
      "Nervio laríngeo recurrente bilateral",
      "Nervio laríngeo superior (rama externa) unilateral",
      "Nervio laríngeo recurrente unilateral",
      "Nervio vago"
    ],
    correctAnswer: 1,
    explanation: "La lesión de la rama externa del nervio laríngeo superior causa parálisis del músculo cricotiroideo, resultando en voz bitonal, pérdida del rango tonal alto y fatiga vocal (especialmente en cantantes). No causa disnea. Es una complicación relativamente común en tiroidectomía por su cercanía con el pedículo vascular tiroideo superior."
  },
  {
    id: 4008,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con masa cervical quística en línea media que se eleva con la deglución y protrusión de la lengua. Diagnóstico más probable:",
    options: [
      "Quiste branquial",
      "Quiste del conducto tirogloso",
      "Higroma quístico",
      "Quiste dermoide"
    ],
    correctAnswer: 1,
    explanation: "El quiste del conducto tirogloso es la anomalía congénita cervical más común. Se localiza en línea media, entre el foramen ciego lingual y la glándula tiroides. Se eleva característicamente con la deglución y protrusión lingual por su relación con el hueso hioides. Requiere resección quirúrgica (procedimiento de Sistrunk) incluyendo la porción central del hueso hioides."
  },
  {
    id: 4009,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "Durante una disección radical de cuello, ¿qué estructura marca el límite posterior del triángulo carotídeo?",
    options: [
      "Músculo omohioideo (vientre posterior)",
      "Músculo esternocleidomastoideo",
      "Músculo trapecio",
      "Músculo escaleno anterior"
    ],
    correctAnswer: 0,
    explanation: "El triángulo carotídeo (parte del triángulo anterior del cuello) está delimitado: superiormente por el vientre posterior del digástrico, anteriormente por el vientre superior del omohioideo, y posteriormente por el borde anterior del esternocleidomastoideo. Contiene la bifurcación carotídea, vena yugular interna, nervio vago y ansa cervical."
  },
  {
    id: 4010,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con fractura de C2 (apófisis odontoides) desarrolla disnea y disfagia. ¿Qué complicación neurológica sugiere esto?",
    options: [
      "Lesión del nervio frénico",
      "Lesión de la médula espinal cervical alta",
      "Lesión del nervio vago",
      "Lesión del nervio hipogloso"
    ],
    correctAnswer: 1,
    explanation: "La fractura de la apófisis odontoides con desplazamiento puede comprimir la médula espinal cervical alta. La lesión por encima de C3-C5 (origen del nervio frénico) puede causar parálisis diafragmática y compromiso respiratorio. Los síntomas adicionales incluyen tetraparesia/tetraplejia, pérdida sensorial y disfunción autonómica. Es una emergencia neuroquirúrgica."
  },
  {
    id: 4011,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía cervical, una masa sólida con calcificaciones puntiformes y vascularización aumentada en tiroides sugiere:",
    options: [
      "Adenoma folicular",
      "Bocio multinodular",
      "Carcinoma papilar de tiroides",
      "Tiroiditis de Hashimoto"
    ],
    correctAnswer: 2,
    explanation: "El carcinoma papilar de tiroides muestra en ecografía: nódulo sólido hipoecoico, microcalcificaciones (psamoma bodies), bordes irregulares, vascularización intranodular aumentada y posibles adenopatías metastásicas. Es el cáncer tiroideo más común (80-85%). Las microcalcificaciones tienen alta especificidad para malignidad."
  },
  {
    id: 4012,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué bolsa faríngea derivan las glándulas paratiroides inferiores?",
    options: [
      "Segunda bolsa faríngea",
      "Tercera bolsa faríngea",
      "Cuarta bolsa faríngea",
      "Quinta bolsa faríngea"
    ],
    correctAnswer: 1,
    explanation: "Las paratiroides inferiores (PTH III) derivan del ala dorsal de la tercera bolsa faríngea, junto con el timo. Migran caudalmente, explicando su posición más inferior. Las paratiroides superiores (PTH IV) derivan de la cuarta bolsa. La migración aberrante puede causar paratiroides ectópicas intratiroideas o mediastínicas."
  },
  {
    id: 4013,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante más común del nervio laríngeo recurrente derecho?",
    options: [
      "Nervio laríngeo no recurrente",
      "Bifurcación prematura",
      "Trayecto anterior a la arteria subclavia",
      "Ausencia del nervio"
    ],
    correctAnswer: 0,
    explanation: "El nervio laríngeo no recurrente derecho ocurre en 0.5-1% de la población, asociado con arteria subclavia derecha aberrante (arteria lusoria). En estos casos, el nervio se dirige directamente a la laringe sin recurrir alrededor de la subclavia. Es crucial reconocerlo en cirugía tiroidea para evitar lesión. Es extremadamente raro en el lado izquierdo."
  },
  {
    id: 4014,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Niño de 3 años con estridor inspiratorio, babeo y posición de trípode. Radiografía lateral muestra 'signo del pulgar'. Diagnóstico:",
    options: [
      "Crup viral",
      "Epiglotitis aguda",
      "Cuerpo extraño laríngeo",
      "Laringomalacia"
    ],
    correctAnswer: 1,
    explanation: "La epiglotitis aguda (típicamente por H. influenzae tipo b pre-vacunación) se presenta con: inicio súbito, fiebre alta, estridor inspiratorio, babeo, disfagia, voz apagada y posición de trípode. El 'signo del pulgar' en radiografía lateral es la epiglotis edematosa. Es una emergencia otorrinolaringológica que requiere intubación controlada en quirófano."
  },
  {
    id: 4015,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Síndrome de Claude Bernard-Horner post-disección cervical radical sugiere lesión de:",
    options: [
      "Nervio vago",
      "Ganglio estrellado",
      "Nervio frénico",
      "Tronco simpático cervical"
    ],
    correctAnswer: 3,
    explanation: "El síndrome de Horner (ptosis, miosis, anhidrosis) post-disección cervical resulta de la lesión del tronco simpático cervical o ganglio cervical superior durante la disección de los niveles ganglionares II-IV. El tronco simpático discurre sobre la fascia prevertebral, posterior a la vaina carotídea. La lesión es más común en disecciones radicales extensas."
  },
  
  // Casos clínicos avanzados
  {
    id: 4016,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Disección accidental de la carótida interna en lugar de la externa durante endarterectomía. ¿Qué signo clínico inmediato ayuda a identificarlo?",
    options: [
      "No hay pulsación en arteria temporal superficial",
      "Aumento de presión en globo ocular ipsilateral",
      "Retrogradación de sangre pulsátil oscura",
      "Sangrado profuso incontrolable"
    ],
    correctAnswer: 0,
    explanation: "Durante endarterectomía carotídea, si se clampea accidentalmente la carótida interna en lugar de la externa, la arteria temporal superficial (rama de la externa) continuará pulsando. Si se clampea correctamente la externa, su pulsación desaparece. La carótida externa tiene ramas cervicales, la interna no tiene ramas extracraneales. Esta verificación previene errores fatales."
  },
  {
    id: 4017,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué maniobra quirúrgica facilita la exposición del plexo braquial en el triángulo posterior del cuello?",
    options: [
      "Sección del músculo omohioideo",
      "Retracción del escaleno anterior",
      "Movilización de la vena yugular externa",
      "División del músculo esternocleidomastoideo"
    ],
    correctAnswer: 0,
    explanation: "La sección del vientre inferior del músculo omohioideo mejora significativamente la exposición del plexo braquial y la arteria subclavia en el triángulo posterior del cuello. El omohioideo divide el triángulo en superior (occipital) e inferior (supraclavicular). Su división es un paso estándar en cirugía del plexo braquial y resección de tumores de fosa supraclavicular."
  },
  {
    id: 4018,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con parálisis del hemidiafragma derecho post-cirugía cervical. ¿Qué nervio se lesionó y cuál es su origen?",
    options: [
      "Nervio frénico (C3, C4, C5)",
      "Nervio vago (X par craneal)",
      "Nervio accesorio (XI par craneal)",
      "Ansa cervicalis (C1, C2, C3)"
    ],
    correctAnswer: 0,
    explanation: "El nervio frénico se origina principalmente de C4, con contribuciones de C3 y C5 ('C3, 4, 5 keep the diaphragm alive'). Desciende sobre la superficie anterior del músculo escaleno anterior, bajo el tejido prevertebral. Su lesión durante tiroidectomía, disección cervical o cateterización de vena subclavia causa parálisis diafragmática ipsilateral con elevación del hemidiafragma en radiografía."
  },
  {
    id: 4019,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué tipo celular es característico del carcinoma medular de tiroides?",
    options: [
      "Células foliculares tiroideas",
      "Células C parafoliculares",
      "Células de Hürthle",
      "Linfocitos"
    ],
    correctAnswer: 1,
    explanation: "El carcinoma medular de tiroides se origina de las células C parafoliculares productoras de calcitonina. Representa 3-5% de los cánceres tiroideos. Puede ser esporádico (75%) o familiar (25%, asociado a MEN 2A, MEN 2B). La calcitonina sérica elevada es diagnóstica. Histológicamente muestra depósitos de amiloide. El CEA también puede estar elevado."
  },
  {
    id: 4020,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En angiografía, estenosis >70% de arteria carótida interna se considera indicación para:",
    options: [
      "Tratamiento médico exclusivo",
      "Endarterectomía o stent carotídeo si sintomático",
      "Observación anual",
      "Anticoagulación de por vida"
    ],
    correctAnswer: 1,
    explanation: "Las guías actuales recomiendan revascularización (endarterectomía carotídea o stent) para estenosis carotídea sintomática >50% o asintomática >70% con bajo riesgo quirúrgico. Reduce significativamente el riesgo de ACV ipsilateral. La decisión se basa en: grado de estenosis, síntomas, expectativa de vida, comorbilidades y experiencia del centro. NASCET y ACAS son los estudios seminales."
  }
];
